import PropTypes from 'prop-types';
import { JOURNEY_STATUSES } from '../../../services/utilityFunctions';
import ImageProp from '../../../commonComponents/propTypes/imageProp';
import JourneyStepProp from './journeyStepProp';

const propType = {
  _id: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  targetUsers: PropTypes.arrayOf(PropTypes.string),
  journeyDefault: PropTypes.bool,
  isDefault: PropTypes.bool,
  isSequential: PropTypes.bool,
  totalUsers: PropTypes.number,
  totalFinished: PropTypes.number,
  isFinished: PropTypes.bool,
  contentAvailableBeforePayment: PropTypes.bool,
  // Ordered, but the payment is settled offline and unconfirmed (BRAVON-6462).
  awaitingPaymentConfirmation: PropTypes.bool,
  finishedDate: PropTypes.number,
  status: PropTypes.oneOf(JOURNEY_STATUSES),
  steps: PropTypes.arrayOf(PropTypes.shape(JourneyStepProp.propType)),
  previews: PropTypes.arrayOf(PropTypes.shape(ImageProp.propType)),
};

export default { propType };
